import { UserManagerService } from 'src/app/providers/services/userManager/user-manager.service';
import { Component, OnInit } from '@angular/core';
// import { SLIDER } from 'src/app/configs';
import * as $ from 'jquery';
import { ConfigService } from 'src/app/providers/config/config.service';
import { SkeletonServiceService } from 'src/app/components/skeleton-service.service';
import { Router } from '@angular/router';

// var tabimages = SLIDER.slides;

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {
images = [];
window: any=window;
link =  this.configService.PROXIES.GATWAY_PUB_IMAGES;
    partners: any;
    showLoader = false;
    currentYear = new Date().getFullYear();
constructor(public userService: UserManagerService, private configService: ConfigService,
  private route:Router, public skeleton: SkeletonServiceService) {
  this.configService.$config.subscribe(res => {
    //  console.log('res', res)
    this.loadPartners();
  //   this.userService.loadSlides().then(res => {
  //     this.images = res.slides
  // })
})

// console.log('res', this.configService.$config.thrownError, this.configService.$config )
 }
 openPage(){
  this.route.navigateByUrl('miss')
}
    ngOnInit() {

        // this.loadPartners()
    }
    ngAfterViewInit(){

    }
    open(url){
        // return;
        // if(url.includes('lonacionline.flexbet-software')){
        //     url =  url + '#/turf/home'
        //   }
          url = this.userService.userData ? url + '?session=' + this.userService.userData.session : url;
          url = this.decorateUrl(url)
        window.location.href = url;
      }
      decorateUrl(urlString) {
        var ga = this.window[this.window['GoogleAnalyticsObject']];
        var tracker;
        if (ga && typeof ga.getAll === 'function') {
          tracker = ga.getAll()[0]; // Uses the first tracker created on the page
          urlString = (new this.window.gaplugins.Linker(tracker)).decorate(urlString);
        }
        console.log(urlString)
        return urlString;
      }
      loadPartners(){
        this.showLoader = true
        this.userService.loadActivePartners().then(res =>{
          console.log("active partners", this.userService.partners, res)
          this.partners = this.userService.partners;
          this.showLoader = false;
        })
      }
      removeSpace(str){
        /* str = str.replace(/\s/g,'');
        return str; */
        return str.replace(/\s/g,'');
      }
}
